module.exports = __webpack_public_path__ + "img/USSD.1ff5481b.svg";